<form #form="ngForm" class="app-grid">
    <ng-container *ngIf="deduction">
        <div class="columns-2 font-bold text-color-white no-wrap flex col justify-center">
            {{ selectionCount }} Selected
        </div>
        <mat-form-field class="columns-3 no-labels no-helpers">
            <input
                matInput
                [matDatepicker]="picker"
                [(ngModel)]="deduction.effectiveDate"
                name="effectiveDate"
                placeholder="Select effective date"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="columns-2 app-grid half-gutter">
            <mat-form-field class="columns-7 no-labels no-helpers">
                <input matInput [(ngModel)]="deduction.amount" name="amount" placeholder="Premium" />
            </mat-form-field>
            <mat-form-field class="columns-5 no-labels no-helpers">
                <mat-select [(ngModel)]="deduction.calculatorType" name="calculatorType" placeholder="%/$">
                    <mat-option *ngFor="let dropdownOption of dropdownCalculatorOptions" [value]="dropdownOption.value">
                        {{ dropdownOption.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field class="columns-3 no-labels no-helpers">
            <mat-select
                [(ngModel)]="deduction.benefitDeductionFrequencyId"
                name="benefitDeductionFrequencyId"
                placeholder="Select frequency"
            >
                <mat-option *ngFor="let dropdownOption of dropdownFrequencyOptions" [value]="dropdownOption.value">
                    {{ dropdownOption.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
</form>
